import React from 'react';
import PropTypes from 'prop-types';
import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import PaymentTransactionListScreen from './screens/PaymentTransactionListScreen';

ManagePaymentTransactions.propTypes = {};

function ManagePaymentTransactions(props) {
  return (
    <KT01BaseLayout>
      <div className="container-fluid">
        <Routes>
          <Route path="" element={<PaymentTransactionListScreen />} />
          <Route path="*" element={<>Not found</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default ManagePaymentTransactions;
